import { lazy, Suspense } from "react";
import { Layout } from "@/frontend/components/layout/Layout";
import { HeroSection } from "@/frontend/components/home/HeroSection";
import { ResidencesPreview } from "@/frontend/components/home/ResidencesPreview";
import { HowItWorksSection } from "@/frontend/components/home/HowItWorksSection";
import { CTASection } from "@/frontend/components/home/CTASection";

const GroupOverviewMap = lazy(() =>
  import("@/frontend/components/home/GroupOverviewMap").then(m => ({ default: m.GroupOverviewMap }))
);

const Index = () => {
  return (
    <Layout>
      <HeroSection />
      <ResidencesPreview />
      <section className="pt-8 md:pt-10 pb-16 md:pb-24">
        <div className="container-narrow">
          <div className="text-center mb-8 md:mb-12">
            <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground">
              Where We Are
            </h2>
            <p className="mt-4 text-muted-foreground max-w-2xl mx-auto">
              Explore the locations of all our residences across Portugal.
            </p>
          </div>
          <Suspense fallback={<div className="h-80 md:h-96 bg-muted rounded-xl animate-pulse" />}>
            <GroupOverviewMap />
          </Suspense>
        </div>
      </section>
      <HowItWorksSection />
      <CTASection />
    </Layout>
  );
};

export default Index;
